<template>
  <div class="interface">
    <!-- 导航栏 -->
    <div class="navigation">
      <div class="back" @click="Previouspage()"><<<</div>
      <img :src="logUrlList.home" class="home_img" @click="Maininterface()" />
    </div>
    <div class="subject">
      <div class="header"></div>
      <div class="main">
        <div class="uploadGroup" @click="selectCardface()">
          <div class="upload">点此上传图片</div>
        </div>

        <div style="margin-top: 32px; padding-left: 16px; padding-right: 16px">
          <h6><b>上传须知</b></h6>
          <div>1.图片最小分辨率为{{ pxLimit }}像素，最大为10MB</div>
          <div>2.涉黄、涉暴、涉政等违规图片将无法审核通过</div>
        </div>
        <div v-show="false">
          <form ref="imgUploadForm">
            <input
              ref="uploadInput"
              type="file"
              accept="image/*"
              @change.prevent.stop="upload"
            />
          </form>
        </div>

        <b-modal
          ok-only
          ref="model_error"
          title="提示"
          @ok="handleOk"
          ok-title="确定"
          centered
        >
          <p class="my-4">{{ errorMsg }}</p>
        </b-modal>
      </div>
      <div class="footer"></div>
    </div>
  </div>
</template>
<script>
const logUrl = require("@/common/logUrl.js");
import wx from "weixin-js-sdk";
import axios from "axios";
const config = require("@/common/config.js");
export default {
  name: "SelectCardface_demo",
  data() {
    return {
      logUrlList: logUrl.logUrl,
      bankSerialNumber: "",
      bankCode: "",
      selectParam: "",
      cardOri: 0,
      pxLimit: "1075 * 686",
      imgWlimit: 1075,
      imgHlimit: 686,
      imgSizeLimit: 10 * 1024 * 1024,
      errorMsg: "",
    };
  },
  watch: {
    cardOri: function (newval, oldval) {
      console.log("当前版面方向：" + newval, "之前版面方向：" + oldval);
      if (newval == 0) {
        this.imgWlimit = 1075;
        this.imgHlimit = 686;
        this.pxLimit = "1075 * 686";
      } else if (newval == 1) {
        this.imgWlimit = 686;
        this.imgHlimit = 1075;
        this.pxLimit = "686 * 1075";
      }
      console.log("imgWlimit" + this.imgWlimit);
      console.log("imgHlimit" + this.imgHlimit);
    },
  },
  methods: {
    Previouspage() {
      this.$router.push({
        name: "SelectBusinessProcess",
      });
    },
    Maininterface() {
      this.$router.push({
        name: "HomePage",
      });
    },
    upload: function (event) {
      var that = this;
      console.log(event);
      let file = event.target.files[0];
      let fileSize = file.size;
      console.log(file);
      let url = null;
      if (window.createObjectURL != undefined) {
        // basic
        url = window.createObjectURL(file);
      } else if (window.webkitURL != undefined) {
        // webkit or chrome
        url = window.webkitURL.createObjectURL(file);
      } else if (window.URL != undefined) {
        // mozilla(firefox)
        url = window.URL.createObjectURL(file);
      }
      console.log(url);

      if (fileSize > this.imgSizeLimit) {
        that.errorMsg = "图片大小不能超过10MB";
        that.showErrorMsg();
        that.resetUpload();
      } else {
        let image = new Image();
        let w, h;
        image.src = url;
        image.onload = function () {
          w = image.width; // 图片宽度
          h = image.height; // 图片高度
          image.onload = null; // 避免重复加载

          console.log("图片宽高:" + w + "*" + h);
          console.log("图片大小:" + fileSize / 1024 + "KB");
          if (w >= that.imgWlimit && h >= that.imgHlimit) {
            that.toEditCardface(url);
          } else {
            that.errorMsg = "图片像素不符合要求，图片的像素：" + w + "*" + h;
            that.showErrorMsg();
            that.resetUpload();
          }
        };
      }
    },

    resetUpload: function () {
      var form = this.$refs.imgUploadForm;
      console.log(form);
      form.reset();
    },
    handleOk: function (bvModalEvt) {},
    showErrorMsg: function () {
      this.$refs["model_error"].show();
    },
    hideErrorMsg: function () {
      this.$refs["model_error"].hide();
    },
    selectCardface: function () {
      this.resetUpload();
      this.$refs.uploadInput.click();
      // var that = this;
      // wx.chooseImage({
      //   count: 1, // 默认9
      //   sizeType: ['original', 'compressed'], // 可以指定是原图还是压缩图，默认二者都有
      //   sourceType: ['album', 'camera'], // 可以指定来源是相册还是相机，默认二者都有
      //   success: function(res) {
      //     console.log(res);
      //     var localIds = res.localIds; // 返回选定照片的本地ID列表，localId可以作为img标签的src属性显示图片
      //     var faceImgPath = localIds[0];
      //     console.log('imgPath:' + faceImgPath);
      //     that.checkImg(faceImgPath);
      //   },
      // });
    },
    checkImg: function (imgPath) {
      let that = this;
      wx.getLocalImgData({
        localId: imgPath, // 图片的localID
        success: function (res) {
          var localData = res.localData;
          if (localData.indexOf("data:image") != 0) {
            // 判断是否有这样的头部
            localData = "data:image/jpeg;base64," + localData;
          }
          localData = localData
            .replace(/\r|\n/g, "")
            .replace("data:image/jgp", "data:image/jpeg");
          // 第一个替换的是换行符，第二个替换的是图片类型，因为在IOS机上测试时看到它的图片类型时jgp，
          // 这不知道时什么格式的图片，为了兼容其他设备就把它转为jpeg

          let image = new Image();
          let w, h;
          image.src = localData;
          // 如果有缓存，读缓存
          // if (image.complete) {
          //   w = image.width; // 图片宽度
          //   h = image.height; // 图片高度
          // } else { //否则加载图片

          // }

          image.onload = function () {
            w = image.width; // 图片宽度
            h = image.height; // 图片高度
            image.onload = null; // 避免重复加载
            if (w > that.imgWlimit && h > that.imgHlimit) {
              let imgSize = that.getImgSize(localData);
              console.log("图片宽高:" + w + "*" + h);
              console.log("图片大小:" + imgSize / 1024 + "KB");
              if (imgSize > that.imgSizeLimit) {
                that.errorMsg = "图片大小不能超过10MB";
                that.showErrorMsg();
              } else {
                that.toEditCardface(imgPath);
              }
            } else {
              that.errorMsg = "图片像素不符合要求，图片的像素：" + w + "*" + h;
              that.showErrorMsg();
            }
          };
        },
      });
    },
    getImgSize: function (imgBase64) {
      // 1.需要计算文件流大小，首先把头部的data:image/png;base64,（注意有逗号）去掉。
      var str = imgBase64.split(",")[1];
      // 2.找到等号，把等号也去掉
      var equalIndex = str.indexOf("=");
      if (str.indexOf("=") > 0) {
        str = str.substring(0, equalIndex);
      }
      // 3.原来的字符流大小，单位为字节
      var strLength = str.length;
      // 4.计算后得到的文件流大小，单位为字节
      var fileLength = parseInt(strLength - (strLength / 8) * 2);
      return fileLength;
    },
    toEditCardface: function (imgPath) {
      var selectParam = JSON.stringify(this.selectParam);
      this.$router.push({
        name: "EditCardface_demo",
        params: {
          imagePath: imgPath,
          bankSerialNumber: this.bankSerialNumber,
          bankCode: this.bankCode,
          //   selectParam: selectParam,
          //   cardOri: this.cardOri,
        },
      });
    },
  },
  mounted: function () {
    // const userId = sessionStorage.getItem("userId");
    // console.log("userId--->", userId);
    // if (userId == null) {
    //   this.$router.push({
    //     name: "ApplyCard_hs",
    //     params: "",
    //   });
    // }
    // // this.bankSerialNumber = this.$route.params.bankSerialNumber;
    // // console.log("bankSerialNumber:" + this.bankSerialNumber);
  },
  activated: function () {
    this.bankSerialNumber = this.$route.query.bankSerialNumber;
    console.log("bankSerialNumber:" + this.bankSerialNumber);
    this.bankCode = this.$route.query.bankCode;
    console.log("bankCode:" + this.bankCode);
    var selectParam = this.$route.params.selectParam;
    console.log("selectParam:" + selectParam);
    if (selectParam !== undefined) {
      this.selectParam = JSON.parse(selectParam);
    }
  },
};
</script>

<style scoped>
.interface {
  width: 100%;
  background: linear-gradient(top, #3861d5, white);
}
.navigation {
  position: fixed;
  z-index: 1000;
  width: 100%;
  background: linear-gradient(left, #3861d5, white);
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 0 2rem;
}
.home_img {
  width: 1.8rem;
}
.back {
  font-size: 1.2rem;
  font-weight: 700;
  color: white;
}
/* 页面主体内容 */
.subject {
  padding: 10rem 1.8rem 0;
  /* background-color: pink; */
  display: flex;
  flex-direction: column;
  justify-content: center;
}
/* .header {
  background-color: aqua;
  height: 3rem;
} */
/* .main {
  background-color: yellow;
  height: 3rem;
} */

/* .footer {
  background-color: blue;
  height: 3rem;
} */
.uploadGroup {
  width: 8rem;
  height: 8rem;
  border: lightgray solid 1px;
  border-radius: 4px;
  border-style: dashed;
  margin: 0 auto;
}
.upload {
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  color: white;
  font-size: 1rem;
  font-weight: 700;
}
.cardOriGroup {
  display: flex;
  flex-direction: row;
  justify-content: center;
  text-align: center;
  align-items: flex-end;
  height: 64px;
}

.cardOriGroup input {
  display: none;
}

.cardOriGroup label {
  color: gray;
  line-height: 28px;
  min-width: 20vw;
  min-height: 28px;
  text-align: center;
  border-radius: 4px;
  margin: 8px;
}

.cardOriGroup input:checked + label {
  background-size: 21px 21px;
  font-weight: bold;
  color: black;
  margin: 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/DIYApplyCardSurface/ApplicationCard/CustomLayout/SelectCardface_demo.vue